import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";

class ViewPixelogCard extends Component {

	constructor(props) {

		super(props);

	    this.state = {
	       stateStyle: 'card-width',
	       stateSrc: null,
	    };
	}	

  	componentDidMount() {

		const {  dataKey, frames, created_at, type } = this.props;

		if(created_at !== null){

		    var year = created_at.substring(2,4);
		    var month = created_at.substring(5,7);
		    var day = created_at.substring(8,10);

            // ai 이미지경로
            if(type == 1){
                var imgSrc = `/outputs/txt2img/20${year}-${month}-${day}/${dataKey}.png`;
            }else{
                var imgSrc = `/upload/${year}/${month}/${day}/${dataKey}.png`;
            }
		    var gifSrc = `/upload/${year}/${month}/${day}/${dataKey}.gif`;

		    var src;
		    var w = ""; 
		    var h = ""; 
		    var img = new Image();

			const scope = this;
		    img.onload = function(){

		        w = this.width;
		        h = this.height;

		        if(frames > 1){
		        	src = gifSrc;
		        }else{
					src = imgSrc;
		        }

		        //가로값이 더 클경우 
		        if(w > h){
				    scope.setState({
				      stateStyle: 'card-width',
				      stateSrc: src
				    });

				//세로값이 더 클경우
		        }else if(h > w){
				    scope.setState({
				      stateStyle: 'card-height',
				      stateSrc: src
				    });		        			        	

				//같을경우
		        }else{
				    scope.setState({
				      stateStyle: 'card-width',
				      stateSrc: src
				    });	
		        }
		    };

			img.src = imgSrc;
		}
    }

	shouldComponentUpdate(nextProps, nextState){
		return true;
	}

	render(){

		const {  stateStyle, stateSrc } = this.state;

		return (
			<div className="img-container">
				<img 
					className={stateStyle}
					src={stateSrc}
				/>
			</div>
		);//return
	}//render
}

export default ViewPixelogCard;